import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import { renderAdmin } from '../Common/Utilities';
import "./Header.css";

class Header extends Component {

    constructor(props) {
        super(props);
        this.renderActive = this.renderActive.bind(this);
        this.logout = this.logout.bind(this);
    }

    renderActive(pathname) {
        return this.props.routing.location.pathname === pathname ? ' active' : '';
    }

    logout() {
        this.props.signOut();
    }

    renderAuthSection() {
        if (this.props.user.isAuthenticated) {
            return (
                <li className={"nav-item"}>
                    <button type="button" className={'btn btn-outline-info my-2 my-sm-0'} onClick={() => this.logout()}>Logout</button>
                </li>
            );
        } else {
            return (
                <li className={"nav-item" + this.renderActive('/login')}>
                    <Link className={"nav-link"} to="/login">Login</Link>
                </li>
            );
        }
    }

    render() {
        return (
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                <Link className="navbar-brand mb-0 h1" to="/">594 Dynasty League!</Link>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav mr-auto">
                        <li className={"nav-item" + this.renderActive('/')}>
                            <Link className="nav-link" to="/">Home <span className="sr-only">(current)</span></Link>
                        </li>
                        <li className={"nav-item" + this.renderActive('/teams')}>
                            <Link className="nav-link" to="/teams">Teams <span className="sr-only">(current)</span></Link>
                        </li>
                        <li className={"nav-item" + this.renderActive('/create-draft') + renderAdmin(this.props.user.isAdmin)}>
                            <Link className="nav-link" to="/create-draft">Create Draft <span className="sr-only">(current)</span></Link>
                        </li>
                        <li className={"nav-item" + this.renderActive('/create-team') + renderAdmin(this.props.user.isAdmin)}>
                            <Link className="nav-link" to="/create-team">Create Team <span className="sr-only">(current)</span></Link>
                        </li>
                        {/* <li className={"nav-item" + this.renderActive('/protected') + renderAuthenticated(this.props.user.isAuthenticated)}>
                            <Link className="nav-link" to="/protected">Protected <span className="sr-only">(current)</span></Link>
                        </li> */}
                    </ul>
                    <ul className="navbar-nav ml-auto">
                        {this.renderAuthSection()}
                    </ul>
                </div>
            </nav>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js